import { render, staticRenderFns } from "./tax-information-form.vue?vue&type=template&id=c13b850c&scoped=true&"
import script from "./tax-information-form.vue?vue&type=script&lang=js&"
export * from "./tax-information-form.vue?vue&type=script&lang=js&"
import style0 from "./tax-information-form.vue?vue&type=style&index=0&id=c13b850c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13b850c",
  null
  
)

export default component.exports